export const flightAirlineOperator = {
    KLM_Flight: "KL",
    TRANSAVIA_Flight: "HV"
}